import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Compass, Home, LifeBuoy } from "lucide-react";
import { PageHero } from "../components/FormKit";

// Branded 404 for unknown routes. Semantics: HTTP 404 Not Found.
// Never silently redirects to Home; always offers safe navigation.
// Renders inside Layout so it stays visible at 320 / 375 / 768px.
export default function NotFound() {
  useEffect(() => {
    document.title = "Page not found · TAVEN SYSTEM LLC";
  }, []);

  return (
    <div data-testid="not-found" data-http-status="404">
      <PageHero
        eyebrow="404"
        title="We can't find that page"
        subtitle="The page you're looking for doesn't exist or may have moved. Let's get you back on track."
      />
      <section className="py-12 px-4 md:px-8 lg:px-12 mx-auto max-w-3xl">
        <div className="bg-white border border-black/10 p-6 sm:p-10 text-center">
          <div className="w-14 h-14 rounded-full bg-taven-gold/15 flex items-center justify-center mx-auto">
            <Compass className="w-6 h-6 text-taven-gold" />
          </div>
          <div className="mt-7 flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/"
              data-testid="notfound-go-home"
              className="inline-flex items-center justify-center gap-2 bg-taven-black text-white px-6 py-3 text-sm font-bold uppercase tracking-wider hover:bg-taven-gold hover:text-taven-black transition-colors"
            >
              <Home className="w-4 h-4" /> Home
            </Link>
            <Link
              to="/help"
              data-testid="notfound-help"
              className="inline-flex items-center justify-center gap-2 border border-black/20 px-6 py-3 text-sm font-bold uppercase tracking-wider hover:border-taven-gold transition-colors"
            >
              <LifeBuoy className="w-4 h-4" /> Help Center
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
